import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Trash from '../../assets/images/Trash.svg';
import Vector from '../../assets/images/Vector.svg';
import Sadface from '../../assets/images/sad-face.svg';
import { Link } from 'react-router-dom';
import '../../scss/style/favouriteComponent.scss';
import { useAuth } from '../../Context/AuthContext';

const baseUrl = 'https://sydney-backend.vercel.app/api/v1/sites';

export default function FavouriteComponent() {
    const [favorites, setFavorites] = useState([]);
    const [cardVisibility, setCardVisibility] = useState({});
    const { deleteFavourite } = useAuth();

    const getOne = (id) => {
        const request = axios.get(`${baseUrl}/${id}`);
        return request.then(response => response.data);
    };

    useEffect(() => {
        const favoriteIds = Object.keys(JSON.parse(localStorage.getItem('favorites')) || {});
        Promise.all(favoriteIds.map(id => getOne(id)))
            .then(favoritesData => {
                setFavorites(favoritesData);

                const initialVisibility = {};
                favoritesData.forEach(favorite => {
                    initialVisibility[favorite.id] = true;
                });
                setCardVisibility(initialVisibility);
            })
            .catch(error => {
                // Handle error, e.g., setting favorites to an empty array
                setFavorites([]);
            });
    }, []);

    const handleDelete = (id) => {
        setCardVisibility(prevVisibility => ({
            ...prevVisibility,
            [id]: false,
        }));

        let favorites = JSON.parse(localStorage.getItem('favorites'));

        delete favorites[id];
        deleteFavourite(id);

        localStorage.setItem('favorites', JSON.stringify(favorites));

        const remainingFavoriteIds = Object.keys(favorites || {});
        if (remainingFavoriteIds.length === 0) {
            setFavorites([]);
        }
    };

    return (
        <div className='favorite-component'>
            {favorites.length === 0 && (
                <div className='no-favourite'>
                    <img className='sad-face' src={Sadface} alt="No favorites" />
                    <p className='no-favourite-text'>No places were added to Favourites yet</p>
                </div>
            )}

            {favorites.length > 0 && (
                favorites.map((favorite, index) => (
                    cardVisibility[favorite.id] && (
                        <div className='favourite-card' key={index}>
                            <div className='icon-holder-fav'>
                                <img className='delete-icon' src={Trash} alt='delete-icon' onClick={() => handleDelete(favorite.id)} />
                            </div>
                            <div className='img-holder-fav-component'>
                                <img className='place-img' src={favorite.images[3]} alt='place-image' />
                            </div>
                            <div className='place-info'>
                                <p className='place-name'>{favorite.name}</p>
                                <p className='place-description'>{favorite.description}</p>
                            </div>
                            <div >
                                <Link className='view' to={`/${favorite.id}/${favorite.name.replace(/\s/g, '')}`}>
                                    <p className='place-link'>View</p>
                                    <img className='view-icon' src={Vector} alt='arrow-icon' />
                                </Link>
                            </div>
                        </div>
                    )
                ))
            )}
        </div>
    );
}
